export default [
  // { value: 3, text: '财经' },
  { value: 8, text: '时尚' },
  { value: 4, text: '军事' },
  { value: 9, text: '汽车' },
  { value: 11, text: '房产' }
  // { value: 10, text: '体育' },
  // { value: 16, text: '游戏' }
]
